<div class="content">
    <div class="slider-container">
        <div class="slider-label" trans>Radius</div>
        <mat-slider min="1" max="300" (input)="roundTool.updatePreview($event.value)" [(ngModel)]="radius"></mat-slider>
    </div>
</div>